import ApiClient from '@services/ApiClient';

export default {
    updateInvoiceData(data) {
        return ApiClient.post('/user/profile/updateInvoiceData', data);
    },

    updateUserData(data) {
        return ApiClient.post('/user/profile/updateData', data);
    },
};
